export const report = (error: string | Error) => window?.Honeybadger?.notify?.(error)
